<template>
  <div id="session-sign-up">
    <Card>
      <template #content>
        <div v-if="!loading" class="infos">
          <MessageList
            :messages="responseMessage.messages"
            :status="responseMessage.status"
          />
          <SignUpForm
            v-if="!hideForm"
            :organizations="organizations || []"
            is-substitute
            with-organization
            @signup="signup"
          />
        </div>
        <i v-else class="pi pi-spin pi-spinner"></i>
      </template>
    </Card>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, reactive } from "vue";
import {
  useAuthorize,
  useRouterUtil,
  useOrganizations,
} from "/@/vue/composables";
import { MessageList } from "/@/vue/components/Atom";
import { SignUpForm } from "/@/vue/components/Organisms";
import { MessageStatus, SingUpResponse, User } from "/@/types";
import Card from "primevue/card";

// organizations

const { getOrganizations } = useOrganizations();
const { data: organizations } = getOrganizations({
  branch: true,
});

// core

const loading = ref<boolean>(false);
const responseMessage = reactive<{
  messages: Array<string>;
  status?: MessageStatus;
}>({
  messages: [],
});

const { signup: userSignup } = useAuthorize();
const { goto } = useRouterUtil();
const signUpResult = ref<SingUpResponse>();

const hideForm = computed<boolean>(() => {
  return (
    signUpResult.value?.status == "confirm" ||
    signUpResult.value?.status == "success"
  );
});

async function signup(userForm: User) {
  loading.value = true;
  signUpResult.value = await userSignup(userForm, { substitute: true });

  switch (signUpResult.value.status) {
    case "reconfirm":
      responseMessage.messages = [
        "認証用のメールを再送信しました。24時間以内にメールを認証して下さい。",
      ];
      responseMessage.status = "success";
      break;
    case "confirm":
      responseMessage.messages = [
        "アカウントを作成し認証用のメールを送信しました。24時間以内にメールを認証して下さい。",
      ];
      responseMessage.status = "success";
      break;
    case "error":
      responseMessage.messages = [
        "アカウント作成に失敗しました。メールアドレスが既に使用されています。ログイン・またはメールアドレスの認証を行って下さい。",
      ];
      responseMessage.status = "error";
      break;
    case "success":
      responseMessage.messages = [
        "アカウントを作成し認証用のメールを送信しました。24時間以内にメールを認証して下さい。",
      ];
      responseMessage.status = "success";
      break;
  }

  loading.value = false;
}
</script>
